import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  roleUsersDelete,
  roleUsersList,
  roleUsersUpdate,
  rolesList,
} from "../../../Redux/Actions";
import { deleteConfirmBox } from "../../Common/Functions/deleteConfirmBox";
import { types } from "../../../Redux/Actions/types";
import { Constants } from "../../Common/Constants";
import dayjs from "dayjs";
import { Dropdown } from "react-bootstrap";
import EditListButton from "../../Common/Fields/EditListButton";
import DeleteListButton from "../../Common/Fields/DeleteListButton";
import PageHeader from "../../Common/PageHeader";
import TableList from "../../Common/UiModel/TableList";
import ReactPagination from "../../Common/Fields/ReactPagination";
import ModalPopup from "../../Common/UiModel/ModalPopup";
import RoleUsersForm from "./RoleUsersForm";
import { Link } from "react-router-dom";
import ReactSelect from "../../Common/Fields/ReactSelect";
import responseMethod from "../../Common/Functions/responseMethod";
import ToggleListField from "../../Common/Fields/ToggleListField";
import usePermissions from "../../Common/Functions/usePermissions";

const ManageUsers = () => {
  const dispatch = useDispatch();
  const { roleuserslist, popupmodel } = useSelector((state) => state.Roles);
  const [roleUsersData, setRoleUsersData] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(
    Constants.statusOptions?.[0]
  );
  // Permissions
  const addPermission = usePermissions(Constants.permission.ROLE_MGT_ADD);
  const editPermission = usePermissions(Constants.permission.ROLE_MGT_EDIT);
  const deletePermission = usePermissions(Constants.permission.ROLE_MGT_DELETE);

  // Get all the roles, and all the user added for those roles
  useEffect(() => {
    dispatch(roleUsersList());
    dispatch(rolesList());
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (search) getData(search);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const getData = (searchKey) => {
    const data = { search: searchKey || "", status: selectedStatus.value };
    dispatch(roleUsersList(data));
  };

  useEffect(() => {
    // Set role Users data
    setRoleUsersData(roleuserslist.userObj);
  }, [roleuserslist]);

  const onDelete = (delete_id) => {
    // Delete role Users
    deleteConfirmBox().then((result) => {
      if (result.isConfirmed) {
        dispatch(roleUsersDelete(delete_id)).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            const data = { search, status: selectedStatus.value };
            dispatch(roleUsersList(data));
            dispatch({ type: types.DELETE_ALERT_VISIBLE });
          }
        });
      }
    });
  };

  const triggerToggle = (rowData) => {
    // Trigger status toggle for news
    const data = {
      status:
        rowData?.status === Constants.status.ACTIVE
          ? Constants.status.INACTIVE
          : Constants.status.ACTIVE,
    };
    dispatch(roleUsersUpdate(rowData?._id, data)).then((response) => {
      const data = { search, status: selectedStatus.value };
      responseMethod(response, dispatch, roleUsersList, data);
    });
  };

  // Columns to free Video Table List
  const columns = [
    {
      name: Constants.id,
      width: "6%",
      cell: (_row, i) =>
        pageIndex * Constants.limitCount - Constants.limitCount + i + 1,
    },
    {
      name: Constants.name,
      cell: (row) => <Link onClick={() => onEdit(row)}>{row?.name}</Link>,
    },
    {
      name: Constants.email,
      cell: (row) => (
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title={row?.email}
        >
          {row?.email?.slice(0, 15) + "..."}
        </span>
      ),
    },
    {
      name: Constants.number,
      cell: (row) => `${Constants.dialCodes} ${row?.mobile}`,
    },
    {
      name: Constants.role,
      cell: (row) => row?.role?.name,
    },
    {
      name: Constants.statuss,
      cell: (row) =>
        row.status === Constants.status.ACTIVE
          ? Constants.published
          : Constants.notPublished,
    },
    {
      name: Constants.createdDate,
      cell: (row) => dayjs(row?.createdAt).format(Constants.dateFormat),
    },
    // Dropdown to edit , delete the user or change the status of that user
    {
      name: Constants.actions,
      cell: (row) => (
        <div className="switch-tn2 position-relative btn-h">
          <div className="remove-drop-ic">
            <Dropdown className="dropdown user-profilem">
              <Dropdown.Toggle
                as="a"
                className="nav-link dropdown-toggle pulse p-0 margin-b"
                href="#!"
                role="button"
              >
                <i
                  className="fa fa-ellipsis-h ellips-t cursor-pointer"
                  aria-hidden="true"
                ></i>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu rounded-lg shadow  btn-lists dropdown-animation dropdown-menu-end  mt-1 ">
                <div className="outer-dot2 btn-list2">
                  {editPermission && (
                    <>
                      <div className="list-group">
                        <EditListButton
                          onClick={() => {
                            onEdit(row);
                          }}
                        />
                      </div>
                      <div className="list-group">
                        <ToggleListField
                          label={Constants.statusKey}
                          onChange={() => {
                            triggerToggle(row);
                          }}
                          checked={row.status === Constants.status.ACTIVE}
                        />
                      </div>
                    </>
                  )}
                  {deletePermission && (
                    <div className="list-group">
                      <DeleteListButton
                        onClick={() => {
                          onDelete(row._id);
                        }}
                      />
                    </div>
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      ),
    },
  ];

  // Delete the action if user does not have permission
  if (!editPermission && !deletePermission) {
    const index = columns.findIndex((elt) => elt.name === Constants.actions);
    if (index !== -1) columns.splice(index, 1);
  }

  // edit the role
  const onEdit = (row) => {
    dispatch({
      type: types.ROLE_USERS_FORM_MODEL,
      payload: {
        msg: Constants.editUser,
        show: true,
        add: 0,
      },
    });
    dispatch({
      type: types.ROLE_USERS_SINGLE,
      payload: row,
    });
  };

  // Pagination function
  const handleOffset = (newOff) => {
    const data = {
      skip: newOff,
      limit: Constants.limitCount,
      search,
      status: selectedStatus.value,
    };
    dispatch(roleUsersList(data));
  };

  const handleStatus = (status) => {
    setSelectedStatus(status);
    const data = {
      search,
      status: status?.value,
    };
    setPageIndex(1);
    dispatch(roleUsersList(data));
  };

  const onResetFilter = () => {
    setSearch("");
    setSelectedStatus(Constants.statusOptions?.[0]);
    setPageIndex(1);
    dispatch(roleUsersList());
  };

  return (
    <div className="container-xxl mt-3">
      <PageHeader
        buttonLink={addPermission}
        pagetitle={Constants.usersList}
        onClick={(e) => {
          e.preventDefault();
          dispatch({
            type: types.ROLE_USERS_FORM_MODEL,
            payload: { msg: Constants.addUser, show: true },
          });
        }}
      />
      <div className="row mb-4 align-items-end position-relative justify-content-end">
        <div className="col-md-2">
          <ReactSelect
            label={`${Constants.statusKey}`}
            required={false}
            options={Constants.statusOptions}
            onChange={(selected) => handleStatus(selected)}
            value={selectedStatus}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">{Constants.search}</label>
          <input
            className="px-2 filter-sec-trans"
            type="search"
            value={search}
            placeholder={Constants.searchByName}
            onChange={(event) => {
              setSearch(event.target.value);
              setPageIndex(1);
              if (event.target.value === "") {
                setSearch("");
                getData("");
              }
            }}
          ></input>
        </div>
        <div className="col-md-1 reset-btn">
          <button
            className="btn btn-primary text-uppercase px-4  cross-reset p-right fw-bold"
            onClick={() => onResetFilter()}
          >
            {Constants.reset}
          </button>
        </div>
      </div>
      <TableList
        columns={columns}
        data={roleUsersData}
        defaultSortFieldId
        highlightOnHover
      />
      {roleuserslist?.total > Constants.limitCount && (
        <ReactPagination
          itemsPerPage={Constants.limitCount}
          total={roleuserslist?.total}
          page={(target) => setPageIndex(target + 1)}
          newOffset={handleOffset}
        />
      )}
      <ModalPopup
        show={popupmodel}
        onHide={() => {
          dispatch({ type: types.ROLE_USERS_SINGLE, payload: "" });
          dispatch({ type: types.ROLE_USERS_FORM_MODEL, payload: "" });
        }}
        dialogClassName={"modal-md"}
        title={popupmodel.msg}
        component={<RoleUsersForm />}
      />
    </div>
  );
};

export default ManageUsers;
